/* HC - IB Gift Engine manifest loader (workstream A3) - 2026-07-19
 *
 * Loads assets/ib-gift-manifest.json once at page init and caches it.
 * Exposes window.IBGiftManifest with:
 *   init(url) — start (or reuse) the single fetch; returns a promise.
 *   get()     — returns the same promise (or a resolved null if never init'd).
 *
 * Contract:
 *   - Exactly one network fetch per page, no matter how many callers.
 *   - Every failure path resolves to null. This module never throws into the
 *     page and never rejects — the gift engine fails open, the storefront
 *     never notices.
 *   - MUST NOT be called from an add-to-cart path. init() belongs in page
 *     bootstrap; by the time a shopper acts the manifest is already resolved.
 */
(function () {
  'use strict';

  if (window.IBGiftManifest) return;

  var manifestPromise = null;

  function warn(message, error) {
    if (window.console && window.console.warn) {
      window.console.warn('[IBGiftManifest] ' + message, error || '');
    }
  }

  function fetchManifest(url) {
    if (!url || typeof window.fetch !== 'function') {
      warn('no manifest URL or fetch unavailable');
      return Promise.resolve(null);
    }
    return window
      .fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response || !response.ok) {
          warn('manifest fetch failed with status ' + (response ? response.status : 'none'));
          return null;
        }
        return response.json().catch(function (error) {
          warn('manifest JSON parse failed', error);
          return null;
        });
      })
      .then(function (manifest) {
        /* Accept any ib-gift-manifest/* version — the engine's normalizer
         * owns version semantics. Pinning v1 exactly here once silently
         * rejected the v2 manifest and left the engine dormant. */
        var okSchema = manifest && typeof manifest.schema === 'string' &&
          manifest.schema.indexOf('ib-gift-manifest/') === 0;
        if (!okSchema) {
          if (manifest) warn('unexpected manifest schema: ' + manifest.schema);
          return null;
        }
        return manifest;
      })
      .catch(function (error) {
        warn('manifest fetch errored', error);
        return null;
      });
  }

  window.IBGiftManifest = {
    init: function (url) {
      if (!manifestPromise) {
        manifestPromise = fetchManifest(url);
      }
      return manifestPromise;
    },
    get: function () {
      return manifestPromise || Promise.resolve(null);
    },
    _resetForTests: function () {
      manifestPromise = null;
    }
  };
})();
